import LeadershipIcon from '../assets/leadership_icon.webp';
import AdaptabilityIcon from '../assets/adaptability_icon.webp';
import TenacityIcon from '../assets/tenacity_icon.webp';
import ContinuousImprovementIcon from '../assets/continuous_improvement_icon.webp';
import CollaborationIcon from '../assets/collaboration_icon.webp';
import AgilityIcon from '../assets/agility_icon.webp';

const PRINCIPLES = {
    ICONS: [
        LeadershipIcon, 
        AdaptabilityIcon, 
        TenacityIcon, 
        ContinuousImprovementIcon,
        CollaborationIcon,
        AgilityIcon
    ]
}

export default PRINCIPLES;